import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
  const { logos, logo, title, description, linkText, link, secondLinkText, secondLink } = props;

  const resolvedLogos = Array.isArray(logos) && logos.length > 0 ? logos : (logo ? [logo] : []);

return (
    <div className="project">
      <div className="project-container">
        <div className="project-logos" aria-label="Project technologies">
          {resolvedLogos.slice(0, 4).map((src, idx) => (
            <div className="project-logo" key={`${src}-${idx}`}>
              <img src={src} alt={`Technology logo ${idx + 1}`} loading="lazy" />
            </div>
          ))}
        </div>

        <div className="project-title">{title}</div>
        <div className="project-description">{description}</div>

        <div className="project-links">
          {link && (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <div className="project-link">
                <div className="project-link-icon">
                  <FontAwesomeIcon icon={faLink} />
                </div>
                <div className="project-link-text">{linkText}</div>
              </div>
            </a>
          )}

          {secondLink && secondLinkText && (
            <a href={secondLink} target="_blank" rel="noopener noreferrer">
              <div className="project-link">
                <div className="project-link-icon">
                  <FontAwesomeIcon icon={faLink} />
                </div>
                <div className="project-link-text">{secondLinkText}</div>
              </div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Project;


